import { EmojiSelector } from '../../components/emoji/emoji-selector';
import { Tag } from '../../lib/extensions/tag';
import { matchers } from '../config/matchers';

const EXTENSION_NAME = 'emoji';

export const Emoji = Tag.extend({
	name: EXTENSION_NAME,
	addOptions() {
		return {
			...this.parent?.(),
			char: ':',
			component: EmojiSelector,
			matchQuery: matchers.emoji.possible,
		};
	},
});
